import React, { ChangeEvent } from 'react';
import { z } from 'zod';

export const groupItemSchema = z.object({
    id: z.string(),
    title: z.string(),
});

export type GroupItem = z.infer<typeof groupItemSchema>;

interface GroupSelectProps {
    id: string;
    value: string;
    show: boolean;
    label: string;
    data: Array<GroupItem>;
    setGroup: (groupId: string) => void;
}

const GroupSelect: React.FC<GroupSelectProps> = props => {
    const options = props.data.map((option, key) => (
        <option key={key} value={option.id}>
            {option.title}
        </option>
    ));

    const onChangeGroup = (event: ChangeEvent) => {
        props.setGroup((event.currentTarget as HTMLInputElement).value);
    };

    if (!props.show) {
        return <div className="tc__group-select" />;
    }

    const value = props.value;
    const label = props.label;

    return (
        <div className="form__cell">
            <label className="form__label" htmlFor={props.id}>
                {label}
            </label>
            <div className="custom-select">
                <select id={props.id} onChange={onChangeGroup} value={value}>
                    {options}
                </select>
            </div>
        </div>
    );
};

export default GroupSelect;
